import gsap from "gsap";

const TRIGGERS = '.ajax_add_to_cart, .add_to_cart_button, .atc-popup__related-add-to-cart';

const cart = {
    init() {
        document.addEventListener('click', (event) => {
            const button = event.target.closest(TRIGGERS);
            const step = event.target.closest('[data-quantity-up], [data-quantity-down]');

            if (button) {
                const card = button.closest('li.product, .atc-popup__related-product');

                this.fly(button, card ? card.querySelector('img') : null);
                this.track(button);
            }

            if (step) {
                this.bump(step);
            }
        });

        document.addEventListener('submit', (event) => {
            const form = event.target.closest('form.cart');

            if (form) {
                const button = form.querySelector('button[name="add-to-cart"]');

                this.fly(button, document.querySelector('.woocommerce-product-gallery img'));
                this.track(button);
            }
        });
    },

    track(button) {
        if (!button || !button.classList.contains('loading')) {
            return;
        }

        new MutationObserver((records, observer) => {
            if (button.classList.contains('loading')) {
                return;
            }

            observer.disconnect();

            if (document.querySelector('.atc-popup-overlay.active')) {
                button.classList.add('ex-added');
                setTimeout(() => button.classList.remove('ex-added'), 2400);
            }
        }).observe(button, { attributes: true, attributeFilter: ['class'] });
    },

    bump(step) {
        const field = step.closest('[data-quantity]');
        const input = field ? field.querySelector('[data-quantity-input]') : null;

        if (input) {
            gsap.fromTo(input, { scale: 1.2 }, { scale: 1, duration: 0.5, ease: 'back.out(3)', clearProps: 'transform' });
        }
    },

    target() {
        return Array.from(document.querySelectorAll('.header__menu-item-cart .icon-cart')).find((icon) => icon.getBoundingClientRect().width > 0) || null;
    },

    fly(button, image) {
        const icon = this.target();

        if (!button || !image || !icon || !button.classList.contains('loading')) {
            return;
        }

        const from = image.getBoundingClientRect();
        const to = icon.getBoundingClientRect();

        if (!from.width || !from.height) {
            return;
        }

        const clone = document.createElement('img');

        clone.src = image.currentSrc || image.src;
        clone.alt = '';
        clone.className = 'ex-fly';
        clone.style.left = from.left + 'px';
        clone.style.top = from.top + 'px';
        clone.style.width = from.width + 'px';
        clone.style.height = from.height + 'px';
        document.body.appendChild(clone);

        const x = to.left + to.width / 2 - (from.left + from.width / 2);
        const y = to.top + to.height / 2 - (from.top + from.height / 2);

        gsap.timeline({
            onComplete: () => {
                clone.remove();
                gsap.fromTo(icon, { scale: 1.4, transformOrigin: '50% 50%' }, {
                    scale: 1,
                    duration: 0.7,
                    ease: 'elastic.out(1, 0.4)',
                    clearProps: 'transform,transformOrigin',
                });
            },
        })
            .to(clone, { scale: 1.08, duration: 0.2, ease: 'power2.out' })
            .to(clone, { x, duration: 0.9, ease: 'power2.inOut' }, 0.15)
            .to(clone, { y, duration: 0.9, ease: 'back.in(1.7)' }, 0.15)
            .to(clone, { scale: 0.08, rotation: 25, borderRadius: '50%', duration: 0.9, ease: 'power2.in' }, 0.15)
            .to(clone, { opacity: 0, duration: 0.2 }, 0.9);
    },
};

export default cart;
